import { OperationVariables } from '@apollo/client';
import type { useQuery } from '@apollo/client/react';

import { GET_TOC_FEATURED_ARTICLE } from '../../../../models/table-of-contents/queries.gql';
import { SLUG } from '../../../../models/table-of-contents/constants';
import useGetLatestArticles from '../use-get-latest-articles';
import useGetTotalArticles from '../use-get-total-articles';
import useTableOfContents from '../../../../cms/utils/use-table-of-contents';

type UseGetLatestArticlesWithFeaturedParams = {
  options: useQuery.Options<any, OperationVariables>;
};

const useGetLatestArticlesWithFeatured = ({ options }: UseGetLatestArticlesWithFeaturedParams) => {
  const { data: articlesData, error: articlesError, isLoading: isArticlesLoading } = useGetLatestArticles({ options });
  const {
    items: featuredArticleData,
    error: featuredArticleError,
    loading: isFeaturedArticleLoading,
  } = useTableOfContents({
    query: GET_TOC_FEATURED_ARTICLE,
    skip: options.skip ?? false,
    slug: SLUG.FEATURED_ARTICLE,
    typename: 'Article',
  });
  const {
    totalArticles,
    isLoading: isTotalArticlesLoading,
    error: totalArticlesError,
  } = useGetTotalArticles(options.variables?.type);

  return {
    articlesData,
    error: articlesError || totalArticlesError,
    featuredArticleData: featuredArticleError ? null : featuredArticleData,
    isLoading: isArticlesLoading || isFeaturedArticleLoading || isTotalArticlesLoading,
    totalArticles,
  };
};

export default useGetLatestArticlesWithFeatured;
